import {useQuery} from "@tanstack/react-query";
import {readAccountAddressListApi} from "../../../../../api/correspondent/CorresspondentApi";
import {BasicSearchType} from "../../../../../types/common/basic";

type Props = {
    searchData: BasicSearchType & { accountId: string };
};

/**
 * 거래처 주소 검색
 * @param props
 * @returns
 */
export const useReadAccountAddressList = ({searchData}: Props) => {
    const {data} = useQuery({
        queryKey: ["readAccountAddressList", searchData],
        queryFn: async () => await readAccountAddressListApi(searchData),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
